import { createFileRoute } from "@tanstack/react-router";
import CultivationCheck from "../../app/views/cultivation/cultivationCheck";

const CultivationStart = () => <CultivationCheck cultivationType="odling" />;

export const Route = createFileRoute("/cultivation/start")({
  component: CultivationStart,
});
